import { Component, Input, OnChanges, OnInit, Output, SimpleChanges, EventEmitter, ViewChild } from '@angular/core';
import { DxAccordionComponent } from 'devextreme-angular';
import { ValidationService, Errors } from '../validation.service';
import { AppEventService, RestDataService, UtilsService, DiagramSelectionService, DataCacheService } from 'pumpcalc-core';
import { environment } from '../../environments/environment';
import { FormSectionService } from '../form-section.service';
import { PumpsetBuilderFormService } from './pumpset-builder-form.service';
import { StatusBarService } from 'pumpcalc-core';
import { alert } from 'devextreme/ui/dialog'; 

@Component({
  selector: 'app-pumpset-builder-form',
  templateUrl: './pumpset-builder-form.component.html',
  styleUrls: ['./pumpset-builder-form.component.css']
})
export class PumpsetBuilderFormComponent implements OnInit {

  @Input() pumpsetId;
  @ViewChild('accordion') accordion: DxAccordionComponent;
  pumpset;  
  sections = [];
  justSelected = false;
  validPumpset = false;
  errors = {};
  saveMessage;
  status = this.statusBarService.statusInfo("");
  plusup=String.fromCharCode(0x002B) + " " + String.fromCharCode(0x2191);
  plusdown=String.fromCharCode(0x002B) + " " + String.fromCharCode(0x2193);  

  constructor(
    private utilsService: UtilsService,
    private formSectionService: FormSectionService,
    private appEventService: AppEventService,
    private restDataService: RestDataService,
    private diagramSelectionService: DiagramSelectionService,
    private validationService: ValidationService,
    private pumpsetBuilderFormService: PumpsetBuilderFormService,
    private dataCacheService: DataCacheService,
    private statusBarService: StatusBarService,    
  ) {
    appEventService.events.subscribe(event => {      
      if (event.name == "SELECTION" && event.context == "Pumpset") { this.loadPumpSetDetails(event.data, true) }
      if (event.name == "SAVE") { this.doSave(); }
      if (event.name == "SAVED") {
        this.status = this.statusBarService.statusInfo("'" + event.data.name + "' Saved");
        this.loadPumpSetDetails(event.data, false);
      }
      if (event.name == "CHANGE") { this.saveMessage = null; }
      if (event.name == "SHARE") {  this.appEventService.emit({ name: "PUMPSET-SHARE", context: "pumpset", data: this.pumpset }); }
    })
    diagramSelectionService.diagramElementSelected.subscribe(selection => { this.openSection(selection) });    
  }

  setSections(): void {
    let newSections = [];
    //invert list of booster layers to match diagram, booster layer 1 is closest to backing pump 
    //resetting sections closes the accordion
    let reversedSections = this.utilsService.clone(this.pumpset.pumpsetDetails.boosterLayersDetails).reverse();
    reversedSections.forEach((booster, index) => {
      newSections.push({ template: 'booster', title: 'Booster Layer ' + (reversedSections.length-index), summary: booster.boosterName, data: booster, boosterNumber: (reversedSections.length-index), selector: "b#" + index, error: false });
    });
    newSections.push({ template: 'backing-pump', title: 'Backing Pump', summary: this.pumpset.pumpsetDetails.backingPumpName + " (" + this.pumpset.pumpsetDetails.backingPumpGas +")", data: this.pumpset, numBoosters: this.pumpset.pumpsetDetails.boosterLayersDetails.length, selector: "bp#", error: false });
    this.sections=newSections;
  }

  updateSections() {
    //invert list of booster layers to match diagram, booster layer 1 is closest to backing pump 
    let reversedSections = this.utilsService.clone(this.pumpset.pumpsetDetails.boosterLayersDetails).reverse();
    reversedSections.forEach((booster, index) => {
      this.sections[index].title = 'Booster Layer ' + (reversedSections.length-index);
      this.sections[index].summary = booster.boosterName;
      this.sections[index].boosterNumber = reversedSections.length-index;
      this.sections[index].data = booster;
      this.sections[index].error = false;
    })    
    this.sections[this.sections.length - 1].summary = this.pumpset.pumpsetDetails.backingPumpName + " (" + this.pumpset.pumpsetDetails.backingPumpGas +")";
    this.sections[this.sections.length - 1].error = false;    
  }



  ngOnInit(): void {
    if(this.pumpsetId){this.loadPumpSetDetails({id:this.pumpsetId,isUser:true},true)}
  }

  boosterChange(event:{ number: number, booster: any }) {              
    this.pumpset.pumpsetDetails.boosterLayersDetails[event.number-1] = event.booster;    
    this.pumpset = this.transformPipeWorkForAPI(this.pumpset);
    if (!this.validPumpset) { this.isValidPumpset(); }
    else {this.updateSections();}    
    this.appEventService.emit({ name: "CHANGE", context: "pumpset", data: this.pumpset });
  }

  loadPumpSetDetails(pumpsetSummary: any, prependModified: boolean) {
    this.restDataService.get(this.restDataService.addIdToURL(pumpsetSummary.id, pumpsetSummary.isUser ? environment.customPumpSetDetailsURL : environment.pumpSetDetailsURL)).subscribe((loadedPumpset: any) => {
      loadedPumpset = this.transformPumpsetForClient(loadedPumpset);
      this.pumpsetBuilderFormService.cacheOfficialBoostersForPumpset(loadedPumpset);
      if (prependModified) { loadedPumpset.name = "Modified " + loadedPumpset.name; }
      
      this.setPumpSetAndAnnounce(loadedPumpset);
    });
  }

  setPumpSetAndAnnounce(pumpSet) {
    this.pumpset = pumpSet;    
    this.dataCacheService.put("LAST_LOADED_PUMPSET", this.utilsService.clone(this.pumpset));
    this.appEventService.emit({ name: "CHANGE", context: "pumpset", data: this.pumpset });
    this.setStatusEditing();
    this.setSections();
  }

  transformPumpsetForClient(pumpset: any): any {    
    if(!pumpset.isUser){
      pumpset.dataComment="";
    }
    //change pipework for    
    pumpset.pumpsetDetails.boosterLayersDetails.forEach(booster => {
      booster.pipework.forEach((pipe, index) => {
        pipe.id = index;
        pipe.xdim1 = pipe.xDim1;
        pipe.xdim2 = pipe.xDim2;
        pipe.section = typeof pipe.section == "string" ? pipe.section : (pipe.shapeSection == 0 ? "Circular" : pipe.shapeSection == 1 ? "Annular" : pipe.shapeSection == 2 ? "Rectangular" : "");
        pipe.flexible = pipe.isFlexible == 1;
        pipe.selected = false;
      })
    });
    //cleanup name 
    pumpset.saveName = "" + pumpset.name;
    pumpset.name = this.pumpsetBuilderFormService.cleanPumpSetName(pumpset.name);
    return pumpset;
  }

  transformPipeWorkForAPI(pumpset: any): any {
    pumpset.pumpsetDetails.boosterLayersDetails.forEach(booster => {
      booster.pipework.forEach((pipe, index) => {
        pipe.id = index;
        pipe.xDim1 = pipe.xdim1;
        pipe.xDim2 = pipe.xdim2;
        pipe.shapeSection = pipe.section == "Circular" ? 0 : pipe.section == "Annular" ? 1 : pipe.section == "Rectangular" ? 2 : null;
        pipe.isFlexible = pipe.flexible ? 1 : 0;
      })
    })
    return pumpset;
  }

  changeBackingPump(backingPump) {
    this.pumpset.pumpsetDetails.backingPumpId = backingPump.id;
    this.pumpset.pumpsetDetails.backingPumpName = backingPump.name;
    this.pumpset.pumpsetDetails.numberOfBackingPumpsInParallel = backingPump.parallel;
    this.pumpset.pumpsetDetails.backingPumpGas=backingPump.gas;
    this.updateSections();
    this.appEventService.emit({ name: "CHANGE", context: "backingPump", data: this.pumpset });
  }

  addBoosterAbove(number){    
    this.addBooster(number);
  }


  addBoosterBelow(number){    
    this.addBooster(number-1);
  }

  addBooster(number) {    
    if (this.pumpset.pumpsetDetails.boosterLayersDetails.length >= 6) { alert("<i>You can have a maximum of 6 Booster Layers</i>", "Booster Layers");return; }    
    this.pumpset.pumpsetDetails.boosterLayersDetails.splice(number, 0, {
      "boosterId": null, "boosterName": "", "numberOfBoostersInParallel": 1,
      "pipework": [{ "shapeSection": 0, "length": 0.1, "xDim1": 0, "xDim2": 0, "parallel": 1, "bends": 0, "flexible": false, "xdim1": 0, "xdim2": 0, id: 0, section: "Circular", selected: false }],
      "boosterDetails": {
        "id": null, "isUser": true, "name": "", "initialFrequency": -1, "userMaximumFrequency": 0, "pressureSwitch": 0,
        "rootsId": null, "rootsName": null, "statorTemperature": 363.15, "deltaTemperatureRotorStator": 0, "driveId": null, "driveName": "", changeInitialFrequency: false
      }
    });    
    this.appEventService.emit({ name: "CHANGE", context: "pumpset", data: this.pumpset });
    this.setSections();   
  }

  removeBooster(number) {
    this.pumpset.pumpsetDetails.boosterLayersDetails.splice(number-1, 1);
    this.appEventService.emit({ name: "CHANGE", context: "pumpset", data: this.pumpset });
    this.setSections();
  }

  openSection(selector: string) {
    if (this.justSelected) { this.justSelected = false; return }
    if (!this.formSectionService.openSection(selector, this.sections, this.accordion)) {
      let path = selector.split('#');
      if (path[0] == 'pw') {
        this.formSectionService.openSection('b#' + path[1], this.sections, this.accordion);
      }
    };
  }

  selectElement(selector: string) {
    this.justSelected = true;
    this.diagramSelectionService.selectElementId(selector);
  }

  isValidPumpset() {
    this.errors = {};        
    this.validPumpset = this.validationService.validPumpSet(this.pumpset, this.errors);    
    this.updateSections();
    this.sections.forEach((section, index) => {
      if (this.errors[Errors.boosters][section.boosterNumber-1]) {
        this.sections[index].summary = "Invalid Parameters";
        this.sections[index].error = true;
      }
    })
    if (this.errors[Errors.backingpump] || this.errors[Errors.backingpumpparallel]) {
      this.sections[this.sections.length - 1].error = true;
      this.sections[this.sections.length - 1].summary = "Invalid Parameters";
    }    
    return this.validPumpset;
  }

  closeSections() {
    this.formSectionService.closeAll(this.sections, this.accordion);
  }

  doSave() {
    this.closeSections();
    if (this.isValidPumpset()) {
      this.status = this.statusBarService.statusLoading("Saving Custom Pumpset");
      this.pumpsetBuilderFormService.savePumpset(this.pumpset)
    }
  }

  clearStatus() {
    setTimeout(() => { this.setStatusEditing() }, 3000);
  }

  setStatusEditing() {
    this.status = this.statusBarService.statusInfo("Editing '" + this.pumpset.saveName + "'");
  }

}
